import React from 'react';
import './ButtonList.scss';

export interface ButtonListImports {
    title?: string;
    buttons: {
        text: string;
        uri: string;
    }[];
}

export const ButtonList = ({ inputs }: { inputs: ButtonListImports }) => {
    return (
        <section className="paragraph__button-list kite-container">
            {inputs.title && (
                <h2 className="typestack-title-2">{inputs.title}</h2>
            )}
            <ul>
                {inputs.buttons.map((button, idx) => (
                    <li key={`btn-${idx}`}>
                        <a
                            className="kite-button kite-button--shrinkwrap rk-button kite-button--secondary kite-button--sm"
                            href={button.uri}
                        >
                            {button.text}
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
};
